__turbopack_context__.v({
  "contactButton": "ContactButton-module-scss-module__5y3NhG__contactButton",
});
